import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {FileMessage} from '../models/chat';
import {environment} from '../environments/enviroment';


@Injectable({
  providedIn: 'root'
})
export class FileAdministratorService {

  private domain: string = `${environment.mindxbkUrl}FileAdministrator/`;

  constructor(private http: HttpClient) {}

  uploadFile(file: File): Observable<FileMessage> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const url = `${this.domain}upload_file`;
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    });

    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<FileMessage>(url, formData, {headers});
  }
}
